import React, { useEffect, useState } from "react";

export const useRecaptcha = (login, ref) => {
	const [loading, setLoading] = useState(null);

	const onSubmitWithReCAPTCHA = async (inputs, formPayload, pickTicket) => {
		setLoading(true);
		const token = await ref.current.executeAsync();
		await login(inputs, token, formPayload, pickTicket);
		setLoading(false);
		ref.current.reset();
		return token;
	};

	return { onSubmitWithReCAPTCHA, loading };
};
